import React, { Component } from "react";

// Components
import PersonalInfoForm from "./PersonalInfoForm";

class ProfileData extends Component {
	render() {
		return (
			<div className="col large-col">
				<PersonalInfoForm {...this.props} />
			</div>
		);
	}
}

export default ProfileData;



// WEBPACK FOOTER //
// ./src/components/reviewer/profile/ProfileData.js